import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FacilitiesLegendItemLoading } from '../FacilitiesLegendItem';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  itemDisplayCount: PropTypes.number,
};

const defaultProps = {
  className: undefined,
  itemDisplayCount: 1,
};

const FacilitiesLegendLoading = ({
  className,
  itemDisplayCount,
}) => {
  const classes = cx(
    styles.list,
    className,
  );

  return (
    <ul className={classes}>
      {Array.from(Array(itemDisplayCount), (_, i) => (
        <FacilitiesLegendItemLoading key={i} />
      ))}
    </ul>
  );
};

FacilitiesLegendLoading.propTypes = propTypes;
FacilitiesLegendLoading.defaultProps = defaultProps;

export default FacilitiesLegendLoading;
